import React, { useEffect, useState } from "react";
import PageTitle from "../../layouts/PageTitle";
import NewPagination from "../../../common/ui/view/pagination/NewPagination";
import { Button, Badge } from "react-bootstrap";
import { Download, Search } from "lucide-react";
import { useLocation } from "react-router-dom";
import { User_Certificate_Accred } from "../../../config/adminUrlConfig";
import { UserCertificate } from "../../../config/apiServices";

const Accreditation = () => {
  const [currentpage, setCurrentPage] = useState(1); //current pages
  const [totalPages, setTotalPages] = useState(null); //total pages
  const access_token = localStorage.getItem("access_token_admin");

  // 🔹 New state for search & filter
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const [data, setData] = useState([]);
  const location = useLocation();
  const atomId = location.state?.atomId;
  const [recordsPerPage, setRecordsPerPage] = useState(10);

  useEffect(() => {
      console.log("atomId from state:", atomId);
  
      if (!atomId) return;
  
      UserCertificate.get(`${User_Certificate_Accred}/${atomId}?page=${currentpage}&limit=${recordsPerPage}`)
        .then((res) => {
          console.log("API Success:", res.data);
          const responseData = res.data?.data || [];
          setData(responseData);
          setTotalPages(res.data.totalPages)
        })
        .catch((err) => {
          console.error("API Error:", err);
          setData([]);
        });
    }, [atomId]);

  // 🔹 Apply filters without changing original data
  const filteredData = data.filter((item) => {
    const matchName = item.name.toLowerCase().includes(search.toLowerCase());
    const matchStatus = status ? item.type === status : true;
    return matchName && matchStatus;
  });

  return (
    <>
      <PageTitle
        activeMenu="Accreditation"
        motherMenu="Digital Certificates & Accreditation"
      />

      <div className="col-12">
        <div className="card">
          <div className="card-body">
            {/* 🔹 Search + Status Filter Bar */}
            <div className="d-flex justify-content-between align-items-center mb-3 gap-3">
              <div className="flex-grow-1 position-relative">
                <input
                  type="text"
                  className="form-control ps-5"
                  placeholder="Search Event name..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  style={{ height: "42px" }}
                />
                <span
                  className="position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"
                  style={{ pointerEvents: "none" }}
                >
                  <Search strokeWidth={1} />
                </span>
              </div>

              {/* <div style={{ width: "220px" }}>
                <select
                  className="form-select bg-light"
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                  style={{ height: "42px" }}
                >
                  <option value="">Select Status</option>
                  <option value="Winner">Winner</option>
                  <option value="Training">Training</option>
                  <option value="Participation">Participation</option>
                </select>
              </div> */}
            </div>

            {/* Table */}
            <div className="w-100 table-responsive">
              <div id="example_wrapper" className="dataTables_wrapper">
                <table id="example" className="display w-100 dataTable">
                  <thead>
                    <tr>
                      <th>Event Name</th>
                      <th>Date</th>
                      <th className="text-end">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredData?.length > 0 ? (
                      filteredData.map((item, i) => (
                        <tr key={i} className="border-bottom">
                          <td>{item.eventName}</td>
                          <td>{new Date(item.createdAt).toLocaleDateString(
                              "en-IN",
                              {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              },
                            )}</td>
                          <td className="text-end">
                            <Button
                            onClick={()=> window.open(item.link)}
                              size="sm"
                              variant="light"
                              className="border-0"
                              style={{ background: "#F3F4F6" }}
                            >
                              <Download />
                            </Button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6" className="text-center">
                          Data is not available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>

                {/* Pagination */}
                <div className="d-flex justify-content-center py-2">
                  {console.log(
                    "totalPages",
                    totalPages,
                    "currentpage",
                    currentpage
                  )}
                  <NewPagination
  totalPages={totalPages}
  currentPage={currentpage}
  onPageChange={setCurrentPage}
  recordsPerPage={recordsPerPage}
  onRecordsPerPageChange={(val) => {
    setRecordsPerPage(val);
    setCurrentPage(1); // reset page when limit changes
  }}
/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Accreditation;
